import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProfileMomentWeekForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Dia de semana", value: 1 },
    { label: "Final de semana", value: 2 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProfileMomentWeek}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        timerange={false}
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
